import { Head, Link } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import { ServerCrash } from "lucide-react"

export default function InternalError() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Head title="500 - Server Error" />
      <div className="text-center max-w-md">
        <ServerCrash className="h-16 w-16 text-destructive mx-auto mb-6" />
        <h1 className="text-4xl font-mono font-bold mb-2">500</h1>
        <p className="text-xl text-muted-foreground mb-6">
          Something went wrong
        </p>
        <p className="text-muted-foreground mb-8">
          We're working on it. Please try again later.
        </p>
        <div className="flex gap-3 justify-center">
          <Button onClick={() => window.location.reload()}>
            Try Again
          </Button>
          <Button variant="secondary" asChild>
            <Link href="/">Go Home</Link>
          </Button>
        </div>
      </div>
    </div>
  )
}
